import { cloneDeep } from '@lsfe/tools';

export default function arrayToTree(arr, key, pKey) {
    if (!arr || !arr.length) return [];
    const newArr = cloneDeep(arr);

    const result = newArr.reduce((prev, item) => {
        if (prev[item[pKey]]) {
            prev[item[pKey]].push(item);
        } else {
            prev[item[pKey]] = [item];
        }
        return prev;
    }, {});
    Object.keys(result).forEach((prop) => {
        result[prop].forEach((item) => {
            if (result[item[key]]) {
                item.children = result[item[key]];
            }
        });
    });
    return result[0];
}
